/**
 * Auth Utilities
 *
 * These will be implemented by @room/frontend-sdk
 * This is just a placeholder for type exports
 */

export interface SessionUser {
  id: string;
  username: string;
  email: string;
  role: string;
}

export interface APIResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
}

export interface SessionResponse {
  user: SessionUser;
}

// These functions should be imported from @room/frontend-sdk in apps
export const getSessionToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('session_token') ?? localStorage.getItem('pi_session_token');
};

export const removeSessionToken = (): void => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('session_token');
  localStorage.removeItem('pi_session_token');
};

const LOGIN_REDIRECT_KEY = 'auth_redirect_in_progress';
const LOGIN_REDIRECT_TTL_MS = 8000;

export const getLoginRedirectUrl = (returnTo: string): string =>
  `/login?returnTo=${encodeURIComponent(returnTo)}`;

export const shouldRedirectToLogin = (pathname: string): boolean => {
  if (typeof window === 'undefined') return false;
  if (pathname.startsWith('/login')) return false;

  const now = Date.now();
  const existing = window.sessionStorage.getItem(LOGIN_REDIRECT_KEY);
  if (existing) {
    const last = Number(existing);
    if (!Number.isNaN(last) && now - last < LOGIN_REDIRECT_TTL_MS) {
      return false;
    }
  }

  window.sessionStorage.setItem(LOGIN_REDIRECT_KEY, String(now));
  return true;
};

export const clearLoginRedirect = (): void => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
};
